import { Markdown } from '@/sub-luca-plugin/compatible-components';
import Ocr, { IOCR } from './ocr';
import Basic, { IBasic } from './basic';
import classNames from 'classnames';
import './index.scss';

interface IOcrQuestioner extends IOCR {
    type: 'ocr';
}

interface IQaPairQuestioner {
    recordId: string;
    type: 'qaPairQuestioner';
    content: string;
    isFlash?: boolean;
}

export type IQuestioner = {
    role: 'questioner';
} & (IBasic | IOcrQuestioner | IQaPairQuestioner);

const Questioner = (data: IQuestioner) => {
    switch (data.type) {
        case 'basic':
            return <Basic {...data} />;
        case 'ocr':
            return <Ocr {...data} />;
        case 'qaPairQuestioner':
            return (
                <div className={classNames('questioner-container', data.isFlash && 'questioner-container--flash')}>
                    <div className="questioner">
                        <div className="questioner__discribe">
                            <Markdown content={data.content} />
                        </div>
                    </div>
                </div>
            );
        default:
            return null;
    }
};

export default Questioner;
